import { render, staticRenderFns } from "./testingDeail.vue?vue&type=template&id=11fa98f9&scoped=true&"
import script from "./testingDeail.vue?vue&type=script&lang=js&"
export * from "./testingDeail.vue?vue&type=script&lang=js&"
import style0 from "./testingDeail.vue?vue&type=style&index=0&id=11fa98f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fa98f9",
  null
  
)

export default component.exports